<template>
    <div class="topbox">
        <div class="top_content">
            <div class="logobox" @click="logo_go()"></div>

            <div class="toplist">
                <div
                    :class="num == index ? 'listboxcode' : 'listbox'"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="top(index, 0)"
                >
                    <div class="min_box">
                        <div class="list_cn">
                            {{ item.displayName }}
                        </div>
                        <div class="list_en" v-if="lang == 0">
                            {{ item.en }}
                        </div>
                    </div>
                    <!-- 子菜单下拉 -->
                    <div
                        class="list_opt"
                        v-if="item.children && item.children.length > 0"
                    >
                        <div class="list_optmin">
                            <div
                                class="opt_box"
                                v-for="(subItem, index2) in item.children"
                                :key="index2"
                                @click.stop="top(index, index2)"
                            >
                                {{ subItem.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right_box">
                <div class="weather">
                    <!-- <iframe class="w_text" width="320" scrolling="no" height="85" frameborder="0" allowtransparency="true"
					 src="https://i.tianqi.com?c=code&id=6&color=%23c1a356&icon=1&py=leiyang"></iframe> -->
                </div>

                <div class="time_box">
                    <div class="time_text">
                        <span v-if="lang == 0"
                            >{{ year }}年{{ month }}月{{ day }}日</span
                        >
                        <span v-if="lang == 1"
                            >{{ monthnum[month - 1] }}{{ day }}.{{ year }}</span
                        >
                        <span v-if="lang == 2"
                            >{{ year }}年{{ month }}月{{ day }}日</span
                        >
                        <span v-if="lang == 3"
                            >{{ year }}년{{ month }}월{{ day }}일</span
                        >
                    </div>
                    <!--  -->
                    <div class="language_box">
                        <div class="language_text">
                            {{ langtext[lang] }}
                            <img
                                class="l_sj"
                                src="../static/home/sanjiao.png"
                                alt=""
                            />
                        </div>
                        <!--  -->
                        <div class="language_optbig">
                            <div class="language_optbox">
                                <div class="language_opt" @click="langfun(0)">
                                    中文简体
                                </div>
                                <div class="language_opt" @click="langfun(1)">
                                    EN
                                </div>
                                <div class="language_opt" @click="langfun(2)">
                                    JP
                                </div>
                                <div class="language_opt" @click="langfun(3)">
                                    KR
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { menuList } from "@/api/article";

export default {
    name: "top",
    data() {
        // ==========================================
        // 静态菜单配置 — 显示内容的唯一来源（决定顺序、中文名、英文名、子菜单名）
        // API 只提供 id 字段，与静态配置 merge 后作为最终数据源
        // ==========================================
        const menuConfig = [
            {
                name: "首页",
                en: "HOME",
                // no children — 顶部下拉不显示
                _hasChildren: false,
                _page: "home",           // 路由 name
            },
            {
                name: "纪念园",
                en: "ABOUT US",
                _hasChildren: true,
                _page: "memorial",
                children: [
                    { name: "走进纪念园" },
                    { name: "地理位置" },
                    { name: "文化底蕴" },
                    { name: "美图欣赏" },
                    { name: "景区导览" },
                    { name: "特色文创" },
                    { name: "视频欣赏" },
                ],
            },
            {
                name: "造纸文化",
                en: "PAPER CULTURE",
                _hasChildren: false,
                _page: "culture",
            },
            {
                name: "景区景点",
                en: "SCENERY",
                _hasChildren: false,
                _page: "scenery",
            },
            {
                name: "旅游指南",
                en: "TRAVEL GUIDE",
                _hasChildren: true,
                _page: "guide",
                children: [
                    { name: "特色美食" },
                    { name: "酒店住宿" },
                    { name: "交通出行" },
                    { name: "游玩路线" },
                    { name: "景区购物" },
                    { name: "娱乐游玩" },
                ],
            },
            {
                name: "旅游服务",
                en: "SERVICES",
                _hasChildren: true,
                _page: "serves",
                children: [
                    { name: "游客中心" },
                    { name: "旅游小贴士" },
                    { name: "温馨提示" },
                    { name: "法律声明" },
                ],
            },
            {
                name: "新闻资讯",
                en: "NEWS",
                _hasChildren: true,
                _page: "news",
                children: [
                    { name: "行业新闻" },
                    { name: "景区活动" },
                    { name: "公示公告" },
                    { name: "创A专栏" },
                ],
            },
            {
                name: "在线预订",
                en: "BOOK",
                _hasChildren: true,
                _page: "book",
                children: [
                    { name: "预订说明" },
                    { name: "酒店预订" },
                    { name: "美食预订" },
                ],
            },
            {
                name: "智慧旅游",
                en: "SMART TOURISM",
                _hasChildren: true,
                _page: "intelligence",
                children: [
                    { name: "预约景区" },
                    { name: "720°全景" },
                    { name: "智慧导览" },
                    { name: "客流量统计" },
                    { name: "停车场数据" },
                    { name: "最大承载量" },
                ],
            },
            {
                name: "联系我们",
                en: "CONTACT US",
                _hasChildren: false,
                _page: "contact",
            },
        ];

        // 先给静态配置加上 displayName 兼容多语言，以及初始化 id 为空
        const _langlist = ["zh", "en", "jp", "kor"];
        const defaultList = menuConfig.map((item) => {
            const cloned = JSON.parse(JSON.stringify(item));
            cloned.displayName = cloned.name;
            cloned.id = null;
            cloned.language = _langlist[0]; // 默认 zh
            if (cloned.children) {
                cloned.children = cloned.children.map((c) => ({
                    ...c,
                    displayName: c.name,
                    id: null,
                }));
            }
            return cloned;
        });

        return {
            list: defaultList,

            // 保存原始静态配置的引用（用来每次合并）
            staticMenuConfig: menuConfig,

            num: 0,

            day: new Date().getDate(),
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            houer: new Date().getHours(),
            minu: new Date().getMinutes(),
            monthnum: [
                "Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
                "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec.",
            ],

            langtext: ["中文简体", "EN", "JP", "KR"],
            lang: 0,
            langlist: ["zh", "en", "jp", "kor"],
        };
    },
    props: {
        p: Number,
        default: 0,
        required: true,
    },
    watch: {
        $route(to, from) {},
    },
    created() {
        this.num = this.p;
        this.lang = JSON.parse(localStorage.getItem("langs")) || 0;
        this.fetchAndMerge();
    },

    methods: {
        // ========== 核心：拉 API + 按静态配置合并 ==========
        fetchAndMerge() {
            var langKey = this.langlist[this.lang];
            return menuList({ parentId: 0, lang: langKey })
                .then((res) => {
                    // 后端 menu/tree 不按 lang 过滤，返回所有语言
                    // 先过滤出当前语言的数据
                    var apiAll = (res.data || []).filter(
                        (item) => item.language === langKey
                    );

                    // 按静态配置的顺序和内容，与 API 数据 merge
                    var merged = this.staticMenuConfig.map((staticItem, idx) => {
                        // 从 API 数据里找匹配项（按顺序 first match）
                        var apiItem = apiAll[idx];
                        return this._mergeOneLevel(staticItem, apiItem, langKey);
                    });

                    // 填充子菜单 id（API children 按 orderNum 排序返回，和静态配置顺序一致 → 用索引匹配最安全）
                    merged.forEach((item) => {
                        if (item.children && item.children.length > 0 && apiAll.length > 0) {
                            var apiParent = apiAll.find(
                                (a) => a.id === item.id
                            );
                            if (apiParent && apiParent.children) {
                                item.children = item.children.map((staticChild, cIdx) => {
                                    // 按索引匹配（跨语言不依赖 name 相等）
                                    var apiChild = apiParent.children[cIdx];
                                    return this._mergeOneLevel(
                                        staticChild,
                                        apiChild,
                                        langKey
                                    );
                                });
                            }
                        }
                    });

                    this.list = merged;
                    localStorage.setItem("ids", JSON.stringify(merged));
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        // 合并一个层级的静态配置 + API 数据
        _mergeOneLevel(staticItem, apiItem, langKey) {
            var result = { ...staticItem };

            // 显示名：优先 API 返回的 name（可能是当前语言的），否则用静态 name
            if (apiItem && apiItem.name) {
                result.apiName = apiItem.name;
                result.displayName = apiItem.name;
            } else {
                result.displayName = staticItem.name;
            }

            // id 和语言字段从 API 来（子页面必需）
            if (apiItem) {
                result.id = apiItem.id;
                result.language = apiItem.language;
                result.path = apiItem.path;
                result.orderNum = apiItem.orderNum;
                result.parentId = apiItem.parentId;
                result.status = apiItem.status;
                result.zhId = apiItem.zhId;
                result.enId = apiItem.enId;
                result.korId = apiItem.korId;
                result.jpId = apiItem.jpId;
            }

            return result;
        },

        // ========== 路由跳转 ==========
        top(e, a) {
            var item = this.list[e];
            if (!item) return;
            var pageName = item._page;

            // 特殊：智慧旅游 - 预约景区(a==1) 开新窗口
            if (e == 8 && a == 1) {
                window.open(" ", "_blank");
                return;
            }

            if (pageName) {
                var targetQuery = {};
                // 有子菜单的，始终带 num（点击顶级传 0，点击下拉传具体 index）
                if (item.children && item.children.length > 0 && a !== undefined) {
                    targetQuery.num = a;
                }
                var already =
                    this.$route.name == pageName &&
                    JSON.stringify(this.$route.query) ===
                        JSON.stringify(targetQuery);
                if (already) {
                    this.$router.replace("/refresh");
                } else {
                    this.$router.push({
                        name: pageName,
                        query: targetQuery,
                    });
                }
            }
        },

        // ========== 切换语言 ==========
        langfun(e) {
            this.lang = e;
            localStorage.setItem("langs", e);
            var self = this;
            this.fetchAndMerge().then(function () {
                self.$router.go(0);
            });
        },

        // ========== Logo 点击 ==========
        logo_go() {
            if (this.$route.name == "home") {
                this.$router.replace("/refresh");
            } else {
                this.$router.push({ name: "home", query: {} });
            }
        },
    },
};
</script>

<style scoped lang="less">
.topbox {
    height: 121px;
    width: 1920px;
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    background-image: url("../static/home/top.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-family: "sy";
}

.top_content {
    height: 100px;
    width: 1920px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

//
.logobox {
    width: 198px;
    height: 52px;
    background-image: url(../static/home/logo.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
//
.toplist {
    width: 1400px;
    height: 42px;
    display: flex;
    justify-content: center;
}
.listbox {
    height: 42px;
    width: 136px;

    position: relative;
}
.listbox:hover {
    background-image: url(../static/home/box.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.listboxcode {
    height: 42px;
    width: 136px;
    background-image: url(../static/home/box.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    position: relative;
}
.min_box {
    height: 42px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: #c1a356;
    .list_cn {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 4px;
    }
    .list_en {
        font-size: 12px;
        line-height: 12px;
        text-transform: uppercase;
    }
}
//
.listboxcode:hover {
    .list_opt {
        display: block;
    }
}
.listbox:hover {
    .list_opt {
        display: block;
    }
}

.list_opt {
    display: none;
}

.list_optmin {
    width: 102px;
    box-sizing: border-box;
    padding: 6px 4px;
    border: 2px solid #c1a356;
    position: absolute;
    top: 42px;
    left: 17px;
    background-color: #d4d5b3;

    display: flex;
    flex-direction: column;
    align-items: center;
}

.opt_box {
    height: 39px;
    line-height: 39px;
    font-size: 14px;
    color: #021f08;
    border-bottom: 1px solid transparent;
}
.opt_box:hover {
    border-bottom: 1px solid #021f08;
}

//
.right_box {
    display: flex;
}

// 天气
.weather {
    width: 120px;
    height: 50px;
    overflow: hidden;
    position: relative;
}
.w_text {
    position: absolute;
    top: -21px;
    left: -13px;
}

// 时间
.time_box {
    width: 110px;
    height: 47px;
    color: #c1a356;
}
.time_text {
    font-size: 14px;
    line-height: 14px;
    text-align: center;
}
// 语言
.language_box {
    margin-top: 5px;
    width: 110px;
    height: 26px;
    box-sizing: border-box;
    border: 1px solid #c1a356;
    position: relative;
}
.language_text {
    font-size: 14px;
    width: 100%;
    height: 24px;
    line-height: 24px;
    text-align: center;
}
.l_sj {
    width: 14px;
    height: 7px;
    transform: rotate(-90deg) translateX(2px);
}
.language_box:hover {
    .l_sj {
        transform: rotate(0deg) translateY(-2px);
    }
    .language_optbig {
        display: block;
    }
}

.language_optbig {
    display: none;
}

.language_optbox {
    width: 110px;
    box-sizing: border-box;
    padding: 6px 4px;
    border: 2px solid #c1a356;
    position: absolute;
    top: 25px;
    left: 0px;
    background-color: #d4d5b3;

    display: flex;
    flex-direction: column;
    align-items: center;
}
.language_opt {
    height: 29px;
    line-height: 29px;
    font-size: 14px;
    color: #021f08;
    border-bottom: 1px solid transparent;
}
.language_opt:hover {
    border-bottom: 1px solid #021f08;
}
</style>
